import { AppRoute } from '@agentselly/immodossier-shared';
import { cockpitDashboardWidgets } from '~/config/widgets/cockpit/cockpitDashboardWidgets';
import { makeQueryLoaderWidgetsRoute } from '~/helper/makeQueryLoaderWidgetsRoute';

export const Route = makeQueryLoaderWidgetsRoute(
  AppRoute.$LANG_$COMPANYID_PUBLIC_DEMO_COCKPIT_HOME,
  cockpitDashboardWidgets,
  true,
);
